<template>
  <div>
    <EditView />
    <OfficeCollect class="mt20" v-if="$route.params.serveType == 1" />
    <!-- <Feedback class="mt20" v-if="$route.params.serveType == 1" /> -->
    <!-- <WordList class="mt20" v-if="$route.params.serveType == 1" /> -->
  </div>
</template>

<script>
import EditView from "@/views/OfficeNew/OfficeBiz/Comp/EditView";
import OfficeCollect from "@/views/OfficeNew/OfficeBiz/Comp/OfficeCollect";
import WordList from "@/views/OfficeNew/OfficeBiz/Comp/WordList";
import Feedback from "@/views/OfficeNew/OfficeBiz/Comp/Feedback";

export default {
  name: "OfficeBiz",
  components: {
    EditView,
    OfficeCollect,
    WordList,
    Feedback
  },
  props: [],
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {}
};
</script>

<style scoped>
</style>
